module.exports = __webpack_public_path__ + "img/product16.03841017.jpg";